import { Component } from '@angular/core';
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span>Created by <b><a href="http://www.rimtelecom.ma/" target="_blank">RimTelecom</a></b>22 - v.{{lastUpdate | date:'dd.MM.yy'}}</span>
    <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {

  lastUpdate: Date = null;

  constructor() {
    this.lastUpdate = environment.lastUpdate
  }
}
